<template>
  <div class="challenges">
    <challenge
      v-for="challenge in challenges"
      :key="challenge.name"
      :challenge="challenge"
      :isCompleted="user && user.id > 423 && user.id < 1055 && user.challenges && user.challenges.indexOf(challenge.id) !== -1"
    ></challenge>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Challenge from "./Challenge";
import { mapState } from "vuex";

export default {
  name: "Challenges",
  components: { Challenge },
  props: [],
  data: function() {
    return {
      challenges: [
        {
          id: 1,
          name: "new-author",
          title: "New Author",
          description: "Submit your first book",
          points: 250
        },
        {
          id: 2,
          name: "that-was-easy",
          title: "That Was Easy",
          description: "Get your first reader",
          points: 200
        },
        {
          id: 3,
          name: "review-guru",
          title: "Review Guru",
          description: "Look for 2 readers<br />at one time",
          points: 250
        },

        {
          id: 4,
          name: "new-reader",
          title: "New Reader",
          description: "Turn in your first review",
          points: 200
        },
        {
          id: 5,
          name: "eager-reader",
          title: "Eager Reader",
          description: "Turn in 3 reviews",
          points: 300
        },
        {
          id: 6,
          name: "page-turner",
          title: "Page Turner",
          description: "Turn in 7 reviews",
          points: 400
        },

        {
          id: 7,
          name: "seeing-stars",
          title: "Seeing Stars",
          description: "Get 5 reviews",
          points: 250
        },
        {
          id: 8,
          name: "the-right-stuff",
          title: "The Right Stuff",
          description: "Get 15 reviews",
          points: 350
        },
        {
          id: 9,
          name: "milky-way",
          title: "Milky Way",
          description: "Get 30 reviews",
          points: 450
        },
        {
          id: 10,
          name: "book-worm",
          title: "Book Worm",
          description: "Turn in 2 reviews<br />in 7 days",
          points: 200
        },
        {
          id: 11,
          name: "four-eyes",
          title: "Four Eyes",
          description: "Turn in 3 reviews<br />in 7 days",
          points: 250
        },
        {
          id: 12,
          name: "word-sponge",
          title: "Word Sponge",
          description: "Turn in 4 reviews<br />in 7 days",
          points: 300
        }
      ]
    };
  },
  computed: {
    ...mapState({
      user: "user"
    })
  }
};
</script>

<style lang="scss" scoped>
.challenges {
  margin-bottom: 16px;
}
.challenge {
  float: left;
  width: 180px;
  margin: 8px;
  font-family: $font-family;
}
.challenge-icon {
  padding: 8px;
  text-align: center;
  position: relative;
  height: 140px;
}
.challenge-icon-img {
  position: absolute;
  width: 120px;
  margin-left: 0px;
  top: 0;
  left: 48px;
  opacity: 0.6;
  z-index: 0;
}
.challenge-title {
  margin-top: -20px;
  padding: 0px;
  text-align: center;
  font-size: 14pt;
  font-weight: 600;
  color: $color-blue;
}
.challenge-description {
  padding: 0px;
  text-align: center;
  font-size: 12.5pt;
  font-weight: 500;
  color: #111;
}

.challenge-check {
  position: absolute;
  left: 4px;
  top: 20px;
  height: 112px;
  z-index: 10000 !important;
}
.challenge-check-icon {
  margin-left: 114px;
  color: $color-blue;
  font-size: 21pt;
  z-index: 10000 !important;
}
</style>